import { useState } from "react";

export function usePagination({ key, meta }) {
  let [pagination, setPagination] = useState({
    key: key,
    hasMore: true,
    data: [],
    reset: Date.now(),
    meta: meta,
    failed: false,
  });

  return {
    getKey: () => key,
    getMeta: () => pagination.meta,
    getData: () => pagination.data,
    hasMore: () => pagination.hasMore,
    getFailed: () => pagination.failed,
    resetToken: () => pagination.reset,

    setFailed: (bool) => {
      setPagination((pagination) => ({ ...pagination, failed: bool }));
    },

    setMeta: (meta) => {
      setPagination({
        key,
        ...pagination,
        data: [],
        hasMore: true,
        reset: Date.now(),
        failed: false,
        meta: { ...pagination.meta, ...meta },
      });
    },

    prepend: (data) => {
      let existingIds = pagination.data.map((d) => d.id);
      setPagination((pagination) => ({
        key,
        ...pagination,
        data: data
          .filter((d) => !existingIds.includes(d.id))
          .concat(pagination.data),
      }));
    },

    append: (data) => {
      let existingIds = pagination.data.map((d) => d.id);
      setPagination({
        key,
        ...pagination,
        data: [
          ...pagination.data,
          ...data.filter((d) => !existingIds.includes(d.id)),
        ],
        hasMore: data.length > 0,
      });
    },

    reset: () => {
      setPagination({
        key,
        ...pagination,
        data: [],
        hasMore: true,
        reset: Date.now(),
      });
    },

    replace: (compareFn, entry) => {
      setPagination({
        key,
        ...pagination,
        data: pagination.data.map((d) => {
          if (compareFn(d)) {
            return { ...d, ...entry };
          } else {
            return d;
          }
        }),
      });
    },

    remove: (compareFn) => {
      setPagination({
        key,
        ...pagination,
        data: pagination.data.filter((d) => !compareFn(d)),
      });
    },
  };
}
